import { FormInput } from '@systemeio/ui'
import { addPaypal } from 'modules/profile/affiliate-program-settings/api/affiliate-program-settings-api'
import React, { useState } from 'react'
import CreateModal from 'shared/components/create-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { fetchWithErrors } from 'shared/utils/fetch-with-errors'

export interface AffiliateProgramPaypalInterface {
  clientId: string
  secret: string
}

const defaultValues: AffiliateProgramPaypalInterface = {
  clientId: '',
  secret: '',
}

const defaultErrors: AffiliateProgramPaypalInterface = {
  clientId: '',
  secret: '',
}

interface AffiliateProgramPaypalProps {
  onPaypalAdd: (clientId: string) => Promise<void>
}

const AffiliateProgramPaypal = ({ onPaypalAdd }: AffiliateProgramPaypalProps) => {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)
  const [errors, setErrors] = useState<AffiliateProgramPaypalInterface>(defaultErrors)

  const onCreate = async (data: AffiliateProgramPaypalInterface) => {
    await fetchWithErrors(async () => {
      await addPaypal(data)
      await onPaypalAdd(data.clientId)
    }, setErrors)
  }
  return (
    <>
      <button
        className={'primary-link'}
        onClick={e => {
          e.preventDefault()
          setOpened(true)
        }}
      >
        {t('dashboard.settings.affiliate_program.connect_paypal')}
      </button>
      <CreateModal
        requiredFields={['secret', 'clientId']}
        fullCaption={t('dashboard.settings.affiliate_program.add_paypal_credentials')}
        opened={opened}
        needToast={false}
        onCreate={data => onCreate(data)}
        onClose={() => setOpened(false)}
        defaultValues={defaultValues}
        creatable={[
          {
            field: 'clientId',
            onRender: (value, onChange) => (
              <FormInput
                key={'clientId'}
                value={value}
                onChange={e => onChange(e.target.value)}
                label={t('dashboard.settings.affiliate_program.paypal_client_id')}
                error={errors.clientId}
              />
            ),
          },
          {
            field: 'secret',
            onRender: (value, onChange) => (
              <FormInput
                key={'secret'}
                value={value}
                onChange={e => onChange(e.target.value)}
                label={t('dashboard.settings.affiliate_program.paypal_client_secret')}
                error={errors.secret}
              />
            ),
          },
        ]}
      />
    </>
  )
}

export default AffiliateProgramPaypal
